import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { setLoading, setSnackInfo } from '../../../redux/actions/appAction'
import { Table, TableBody, TextField, TableCell, TableContainer, TableHead, TableRow, Paper, Button, Switch, Typography } from '@material-ui/core';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { EditOutlined, DeleteOutlined } from '@ant-design/icons';
import Tooltip from '@material-ui/core/Tooltip';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';
import HttpService from '../../../services/httpService';

const useStyles = makeStyles((theme) => ({
  table: { minWidth: 650 },
  addButton: { backgroundColor: '#FFF2EB', color: '#14419c', marginRight: '0.5em', marginLeft: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#F47E46", color: '#FFF2EB' } },
  editButton: { backgroundColor: '#FFF2EB', color: '#3d444f', marginRight: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#3d444f", color: '#FFF2EB' } },
  deleteButton: { backgroundColor: '#FFF2EB', color: '#9c261e', marginRight: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#9c261e", color: '#FFF2EB' } },
  yesButton: { backgroundColor: '#FFF2EB', color: '#14419c', marginRight: '0.5em', marginLeft: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#14419c", color: '#FFF2EB' } },
  noButton: { backgroundColor: '#FFF2EB', color: '#151921', marginRight: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#151921", color: '#FFF2EB' } },
}));

const StyledTableCell = withStyles((theme) => ({
  head: { backgroundColor: "#ccc", color: theme.palette.common.black },
  body: { fontSize: 14 },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: { '&:nth-of-type(odd)': { backgroundColor: theme.palette.action.hover } },
}))(TableRow);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// Reusable admin CRUD page for a simple named-list master-data type, backed
// by HttpService.{add,update,get,delete}{ServiceType,Scope}Config — used for
// both the Misc Payments "Service Type" and "Scope" config screens.
const MiscPaymentMasterDataConfig = ({ title, api, setLoading: setLoadingProp, setSnackInfo }) => {
  const classes = useStyles();
  const [items, setItems] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [name, setName] = useState("");
  const [editId, setEditId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState("");

  const fetchAll = async () => {
    setLoadingProp(true);
    try {
      const res = await api.getAll();
      setItems(res?.data?.data || []);
    } catch (err) {
      setSnackInfo("Failed to fetch " + title, "error");
    } finally {
      setLoadingProp(false);
    }
  };

  useEffect(() => {
    fetchAll();
    // eslint-disable-next-line
  }, []);

  const handleDialogClose = () => {
    setShowModal(false);
    setName("");
    setEditId(null);
    setIsEdit(false);
  };

  const handleAdd = async () => {
    if (!name.trim()) {
      setSnackInfo("Name is required", "error");
      return;
    }
    setLoadingProp(true);
    try {
      const res = await api.add({ name: name.trim() });
      setSnackInfo(res?.data?.message || `${title.slice(0, -1)} added`, "success");
      handleDialogClose();
      fetchAll();
    } catch (err) {
      setSnackInfo(err?.response?.data?.message || "Something went wrong", "error");
    } finally {
      setLoadingProp(false);
    }
  };

  const handleUpdate = async () => {
    setLoadingProp(true);
    try {
      const res = await api.update({ id: editId, name: name.trim() });
      setSnackInfo(res?.data?.message || `${title.slice(0, -1)} updated`, "success");
      handleDialogClose();
      fetchAll();
    } catch (err) {
      setSnackInfo(err?.response?.data?.message || "Something went wrong", "error");
    } finally {
      setLoadingProp(false);
    }
  };

  const handleToggleActive = async (item) => {
    setLoadingProp(true);
    try {
      await api.update({ id: item._id, isActive: !item.isActive });
      fetchAll();
    } catch (err) {
      setSnackInfo("Failed to update status", "error");
    } finally {
      setLoadingProp(false);
    }
  };

  const openEdit = (item) => {
    setEditId(item._id);
    setName(item.name);
    setIsEdit(true);
    setShowModal(true);
  };

  const closeDeleteModal = () => { setShowDeleteModal(false); setDeleteId(""); };

  const handleDelete = async () => {
    setLoadingProp(true);
    try {
      await api.delete(deleteId);
      closeDeleteModal();
      fetchAll();
      setSnackInfo(`${title.slice(0, -1)} deleted`, "success");
    } catch (err) {
      setSnackInfo(err?.response?.data?.message || "Something went wrong", "error");
    } finally {
      setLoadingProp(false);
    }
  };

  return (
    <div style={{ padding: 16 }}>
      <div style={{ marginBottom: 10, fontSize: 26, textAlign: 'center' }}><b>{title}</b></div>
      <Typography variant="caption" color="textSecondary" style={{ display: 'block', textAlign: 'center', marginBottom: 10 }}>
        Misc Payments master data — values added here appear in the Service Provider Onboarding form.
      </Typography>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button className={classes.addButton} onClick={() => { setShowModal(true); setIsEdit(false); }} variant="contained">
          Add {title.slice(0, -1)}
        </Button>
      </div>
      <div style={{ marginBottom: 10 }} />

      <TableContainer component={Paper}>
        <Table className={classes.table} size="small">
          <TableHead>
            <TableRow>
              <StyledTableCell style={{ textAlign: 'center' }}>Sl No</StyledTableCell>
              <StyledTableCell style={{ textAlign: 'center' }}>Name</StyledTableCell>
              <StyledTableCell style={{ textAlign: 'center' }}>Active</StyledTableCell>
              <StyledTableCell style={{ textAlign: 'center' }}>Action</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item, i) => (
              <StyledTableRow key={item._id}>
                <StyledTableCell style={{ textAlign: 'center' }}>{i + 1}</StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}>{item.name}</StyledTableCell>
                <StyledTableCell style={{ textAlign: 'center' }}>
                  <Switch checked={!!item.isActive} onChange={() => handleToggleActive(item)} size="small" color="primary" />
                </StyledTableCell>
                <StyledTableCell style={{ cursor: 'pointer' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
                    <Tooltip title="Edit" placement="top">
                      <Button className={classes.editButton} variant="contained" size="small" onClick={() => openEdit(item)}>
                        <EditOutlined />
                      </Button>
                    </Tooltip>
                    <Tooltip title="Delete" placement="top">
                      <Button className={classes.deleteButton} variant="contained" size="small" onClick={() => { setShowDeleteModal(true); setDeleteId(item._id); }}>
                        <DeleteOutlined />
                      </Button>
                    </Tooltip>
                  </div>
                </StyledTableCell>
              </StyledTableRow>
            ))}
            {items.length === 0 && (
              <TableRow>
                <StyledTableCell colSpan={4} style={{ textAlign: 'center', padding: 24 }}>
                  No {title.toLowerCase()} added yet.
                </StyledTableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Dialog open={showModal} TransitionComponent={Transition} fullWidth maxWidth="xs" onClose={handleDialogClose}>
        <DialogTitle>{isEdit ? 'Update' : 'Add'} {title.slice(0, -1)}</DialogTitle>
        <DialogContent>
          <DialogContentText />
          <TextField
            label="Name"
            value={name}
            fullWidth
            autoFocus
            onChange={(e) => setName(e.target.value)}
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button className={classes.noButton} variant="outlined" onClick={handleDialogClose}>Cancel</Button>
          <Button className={classes.yesButton} variant="outlined" onClick={isEdit ? handleUpdate : handleAdd}>
            {isEdit ? 'Update' : 'Add'}
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={showDeleteModal} TransitionComponent={Transition} fullWidth maxWidth="xs" onClose={closeDeleteModal}>
        <DialogTitle>Delete {title.slice(0, -1)}</DialogTitle>
        <DialogContent>
          <DialogContentText>Are you sure you want to delete this?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className={classes.noButton} variant="outlined" onClick={closeDeleteModal}>Cancel</Button>
          <Button className={classes.deleteButton} variant="outlined" onClick={handleDelete}>Delete</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(MiscPaymentMasterDataConfig);

// ─── API binding for Service Type config ───────────────────────────────────
export const serviceTypeApi = {
  getAll: () => HttpService.getServiceTypeConfigs(),
  add: (data) => HttpService.addServiceTypeConfig(data),
  update: (data) => HttpService.updateServiceTypeConfig(data),
  delete: (id) => HttpService.deleteServiceTypeConfig(id),
};
